import { tr as __tr, useLocale as __useLocale } from "../i18n/runtime";
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
const AuthContext = createContext();

// استخدم مسار نسبي فقط
const API = '/api';
export const AuthProvider = ({
  children
}) => {
  __useLocale();
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('rehlaty_token'));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  // جلب بيانات المستخدم من السيرفر
  const fetchUser = async () => {
    try {
      const response = await axios.get(`${API}/auth/me.php`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setUser(response.data.user || response.data);
    } catch (err) {
      console.error('Failed to fetch user:', err);
      logout();
    } finally {
      setLoading(false);
    }
  };

  // تسجيل الدخول
  const login = async (email, password) => {
    setError(null);
    try {
      const response = await axios.post(`${API}/auth/login.php`, {
        email,
        password
      });
      const {
        token: accessToken,
        user: userData
      } = response.data;
      localStorage.setItem('rehlaty_token', accessToken);
      setToken(accessToken);
      setUser(userData);
      return userData;
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.message || "فشل تسجيل الدخول");
      throw err;
    }
  };

  // تسجيل مستخدم جديد
  const register = async userData => {
    setError(null);
    try {
      const response = await axios.post(`${API}/auth/register.php`, userData);
      const {
        token: accessToken,
        user: newUser
      } = response.data;
      localStorage.setItem('rehlaty_token', accessToken);
      setToken(accessToken);
      setUser(newUser);
      return newUser;
    } catch (err) {
      console.error('Register error:', err);
      setError(err.response?.data?.message || "فشل إنشاء الحساب");
      throw err;
    }
  };

  // تسجيل الخروج
  const logout = () => {
    localStorage.removeItem('rehlaty_token');
    setToken(null);
    setUser(null);
  };

  // تحديث بيانات المستخدم
  const updateUser = async data => {
    try {
      const response = await axios.put(`${API}/auth/me.php`, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setUser(response.data.user || response.data);
      return response.data;
    } catch (err) {
      console.error('Update user error:', err);
      throw err;
    }
  };

  // صلاحيات المستخدم
  const isAdmin = user?.role === 'admin';
  const isStaff = user?.role === 'staff' || isAdmin;
  const isCustomer = user?.role === 'customer';
  return <AuthContext.Provider value={{
    user,
    token,
    loading,
    error,
    login,
    register,
    logout,
    updateUser,
    isAdmin,
    isStaff,
    isCustomer,
    isAuthenticated: !!user
  }}>
      {__tr(children)}
    </AuthContext.Provider>;
};

// هوك للاستخدام داخل التطبيق
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
